<div class="input-label">
  <span class="standart-text-required-symbol">* </span>
  Practice Management
</div>
<div class="input-wrap select" [class.disabled]="disabled">
  <select
    class="input"
    [(ngModel)]="selectedValue"
    [compareWith]="compareFn"
    [disabled]="disabled"
  >
    <option [value]="''" selected="selected" disabled>
      Select Practice Management
    </option>
    <option *ngFor="let app of applications" [value]="app.code">
      {{ app.description }} ({{ app.code }})
    </option>
  </select>
</div>
